// Generated by ReScript, PLEASE EDIT WITH CARE


var necessary = "necessary";

var analytics_and_performance = "analytics_and_performance";

var marketing = "marketing";

var functional = "functional";

var all = "all";

var box = "box";

var cloudInline = "cloud inline";

var bottomCenter = "bottom center";

var left = "left";

export {
  necessary ,
  analytics_and_performance ,
  marketing ,
  functional ,
  all ,
  box ,
  cloudInline ,
  bottomCenter ,
  left ,
}
/* No side effect */
